const url = "https://apivisaroot.com/api/";
// const url = "http://13.232.52.101/api/";
export default url;
